<template>
    <v-tabs v-model="tab" show-arrows :class="`${!!errorsInTabs.find((x) => x == tab) ? 'v-tabs--error' : ''}`">
        <v-tab
            v-for="(item, index) in items"
            :key="index"
            :class="`${!!errorsInTabs.find((x) => x == index) ? 'v-tab--error' : ''}`"
        >
            <div class="tab">
                <v-slide-x-transition>
                    <v-fade-transition>
                        <v-icon v-if="!!errorsInTabs.find((x) => x == index)" class="error-icon" left dense color="red"
                            >mdi-alert</v-icon
                        >
                    </v-fade-transition>
                </v-slide-x-transition>
                {{ item }}
            </div>
        </v-tab>
    </v-tabs>
</template>

<script>
export default {
    data() {
        return {
            items: [t('dms-users::form.title.details'), t('dms-users::form.title.permissions')],
            tabsErrors: {
                0: [
                    'country',
                    'county',
                    'town',
                    'disabled_permissions',
                    'email',
                    'username',
                    'status',
                    'surname',
                    'forename',
                    'address',
                    'post_code',
                    'second_address',
                    'phone',
                    'fax',
                    'role',
                    'pharmacy_group_id',
                    'pharmacy_sites',
                ],
                1: ['roles'],
            },
        };
    },
    computed: {
        errorsInTabs() {
            const errors = this.$store.state.dms_users.errorMessages.dms_user;
            const Errors = [];
            const errorsInTabs = [];
            Object.keys(errors).forEach((val) => {
                if (errors[val] && errors[val].length) {
                    Errors.push(val);
                }
            });
            Object.keys(this.tabsErrors).forEach((tab) => {
                Object.values(this.tabsErrors[tab]).forEach((error) => {
                    if (Errors.includes(error)) {
                        errorsInTabs.push(tab);
                    }
                });
            });
            return _.sortedUniq(errorsInTabs);
        },
        tab: {
            get() {
                return this.$store.state.dms_users.tab;
            },
            set(value) {
                this.$store.dispatch('dms_users/changeTab', value);
            },
        },
    },
};
</script>
